
export class PrimeNgGuru {

  static GetListSummary(items: any[], calculationProperty: string) {
    if (typeof items !== 'undefined') {
      return {
        total: items.reduce((total, item) => {
          return total + item[calculationProperty];
        }, 0),
        count: items.length
      };
    }
    return {
      total: 0,
      count: 0
    };
  }
  static groupBy(value: Array<any>, field: string): Array<any> {
    const groupedObj = value.reduce((prev, cur) => {
      if (!prev[cur[field]]) {
        prev[cur[field]] = [cur];
      } else {
        prev[cur[field]].push(cur);
      }
      return prev;
    }, {});
    return Object.keys(groupedObj).map(key => ({ key, value: groupedObj[key] }));
  }
  static orderBy(value: Array<any>, field: string): Array<any> {
    value.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return value;
  }
  static groupByAsSelectItem(value: Array<any>, FilterBy: string, OrderBy: string, isAddDefaultValue: boolean = false): Array<any> {
    const selectItm: any = [];
    if (isAddDefaultValue) {
      selectItm.push({ label: 'ALL', value: null });
    }
    this.groupBy(value, FilterBy).forEach((itm) => {
      selectItm.push({ label: itm.key, value: itm.key });
    });
    // return this.orderBy(selectItm, OrderBy);
    return selectItm;
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/helper/primeng.guru.ts